import { CSSObject } from '@emotion/core';

import { themeColor } from '@scripts/themes/cssVars';

export const containerStyles: CSSObject = {
    fontSize: '16px',
    fontWeight: 500,
    color: themeColor.textBlack,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
};
